"use strict";function n(t){return typeof t=="string"}exports.isHostComponent=n;
